module.exports = __webpack_public_path__ + "img/Pazarama.a008c8a4.png";